import { Conversion, DealStatus } from './../../models/models';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ContractsProvider } from '../../providers/api/contracts.provider';
import { ContractDetailPage } from '../contract-detail/contract-detail';

@IonicPage()
@Component({
  selector: 'page-contracts-list',
  templateUrl: 'contracts-list.html',
})
export class ContractsListPage {

  tab = 'TO_FINALIZE'
  contracts_to_finalize: Conversion[]
  contracts_finalized: Conversion[]
  contracts_lost: Conversion[];
  nextFinalizedUrl: string
  nextToFinalizeUrl: string
  nextLostUrl: string;

  DealStatus = DealStatus

  constructor(public navCtrl: NavController, public navParams: NavParams, private readonly contractsProvider: ContractsProvider) {
    this.refresh()
  }

  refresh() {
    this.reset()
    this.getData()
  }

  getData() {
    // Da finalizzare
    this.contractsProvider.getContracts(false, DealStatus.WON).subscribe(data => {
      this.contracts_to_finalize = data.results
      this.nextToFinalizeUrl = data.next
    })

    // Non finalizzato
    this.contractsProvider.getContracts(true).subscribe(data => {
      this.contracts_finalized = data.results
      this.nextFinalizedUrl = data.next
    })

    // Persi
    this.contractsProvider.getContracts(null, DealStatus.LOST).subscribe(data => {
      this.contracts_lost = data.results
      this.nextLostUrl = data.next
    })
  }

  reset() {
    this.contracts_to_finalize = []
    this.contracts_finalized = []
    this.nextFinalizedUrl = ""
    this.nextToFinalizeUrl = ""
  }

  open(contract: Conversion) {
    this.navCtrl.push(ContractDetailPage, {
      contract: contract,
      parent: this
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ContractsListPage');
  }

  nextFinalized(event) {
    if (!this.nextFinalizedUrl) {
      event.complete()
      event.enable(false)
      return
    }

    this.contractsProvider.getNextContracts(this.nextFinalizedUrl).subscribe(
      page => {
        this.contracts_finalized.push(...page.results)
        this.nextFinalizedUrl = page.next
      },
      e => { console.log(e) },
      () => { if (event !== null) event.complete() }
      )
    }

    nextToFinalize(event) {
      if (!this.nextToFinalizeUrl) {
        event.complete()
        event.enable(false)
        return
      }

      this.contractsProvider.getNextContracts(this.nextToFinalizeUrl).subscribe(
        page => {
          this.contracts_to_finalize.push(...page.results)
          this.nextToFinalizeUrl = page.next
        },
        e => { console.log(e) },
        () => { if (event !== null) event.complete() }
        )
      }

    nextLost(event) {
      if (!this.nextLostUrl) {
        event.complete()
        event.enable(false)
        return
      }

      this.contractsProvider.getNextContracts(this.nextLostUrl).subscribe(
        page => {
          this.contracts_lost.push(...page.results)
          this.nextLostUrl = page.next
        },
        e => { console.log(e) },
        () => { if (event !== null) event.complete() }
        )
      }

    }



// WEBPACK FOOTER //
// ./src/pages/contracts-list/contracts-list.ts